<template>
  <!--begin::sidebar menu-->
  <div class="app-sidebar-menu overflow-hidden flex-column-fluid">
    <!--begin::Menu wrapper-->
    <div
      id="kt_app_sidebar_menu_wrapper"
      class="app-sidebar-wrapper hover-scroll-overlay-y mb-5"
      data-kt-scroll="true"
      data-kt-scroll-activate="true"
      data-kt-scroll-height="auto"
      data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer"
      data-kt-scroll-wrappers="#kt_app_sidebar_menu"
      data-kt-scroll-offset="5px"
      data-kt-scroll-save-state="true"
    >
      <KTUserMenu v-if="isLoggedIn" />
      <GuestMenu v-if="!isLoggedIn" />
      <!--begin::Menu-->
      <div
        id="#kt_app_sidebar_menu"
        class="menu menu-column menu-rounded menu-sub-indention px-3"
        data-kt-menu="true"
      >
        <section class="mb-5">
          <div class="menu-content mb-3">
            <span
              class="menu-heading fw-bold text-uppercase text-white fs-7 mb-5"
            >
              Investments
            </span>
          </div>
          <menu-item
            v-for="item in investmentsMenuItems"
            :key="item.route"
            :menuItem="item"
          ></menu-item>
        </section>
      </div>
      <!--end::Menu-->
    </div>
    <!--end::Menu wrapper-->
  </div>
  <!--end::sidebar menu-->
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { sidebarMenuIcons } from "@/core/helpers/config";
import KTUserMenu from "@/layouts/main-layout/menus/UserMenu.vue";
import GuestMenu from "@/layouts/main-layout/menus/GuestMenu.vue";
import MenuItem from "./menu-item.vue";

const investmentsMenuItems = [
  {
    route: "/investment/deals",
    svgIcon: "media/platforms/gabon/icons/menu/available.svg",
    heading: "Available deals",
  },
  {
    route: "/investment/selected",
    svgIcon: "media/platforms/gabon/icons/menu/selected.svg",
    heading: "Selected deals",
  },
  {
    route: "/investment/archived",
    svgIcon: "media/platforms/gabon/icons/menu/archived.svg",
    heading: "Archived deals",
  },
];

export default defineComponent({
  name: "sidebar-menu",
  components: {
    KTUserMenu,
    GuestMenu,
    MenuItem,
  },
  setup() {
    const route = useRoute();
    const store = useStore();

    const scrollElRef = (ref < null) | (HTMLElement > null);
    const isLoggedIn = store.getters["user/isLoggedIn"];

    onMounted(() => {
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    const hasActiveChildren = (match) => {
      return route.path.indexOf(match) !== -1;
    };

    return {
      hasActiveChildren,
      investmentsMenuItems,
      sidebarMenuIcons,
      isLoggedIn,
    };
  },
});
</script>

<style lang="scss" scoped>
.menu-heading {
  color: #2d75b5;
  padding: 0px 14px;
}
</style>
